import React, {useEffect} from "react";
import {useParams} from "react-router-dom";
import {Link} from "react-router-dom";
import {bindActionCreators} from "redux";
import {connect, useSelector} from 'react-redux';
import {Container, Grid, Paper, Typography, Box, Drawer, useTheme, useMediaQuery} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import MainMenu from "../../core/mainMenu";
import {selectCourseById, selectLessonsByCourseId} from "../../../store/course/selectors";
import {Course, Lesson} from "../../../common/course";
import courseActions from '../../../store/course/actions';
import {CommonState} from "../../../store";
import APP_URLs from "../../../consts/url";
import MultiFormatImage from '../../core/multiFormatImage';
import {SIDE_BAR_WIDTH} from "../../../consts/userInterface";

type Props = {
    fetchCourses: Function,
    fetchLessons: Function,
}
const View = ({fetchCourses, fetchLessons}: Props) => {
    const {courseId} = useParams();
    const course: Course = useSelector((state: CommonState) => selectCourseById(state, String(courseId)));
    const lessons: Lesson[] = useSelector((state: CommonState) => selectLessonsByCourseId(state, String(courseId)));
    const theme = useTheme();
    //@ts-expect-error
    const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('md'));
    useEffect(() => {
        fetchCourses();
        fetchLessons(courseId);
    }, []);
    if (!course) {
        return <div></div>
    } 
    return (
        <>
            <MainMenu />
            <Box sx={{display: 'flex'}}>
                {!isSmallScreen && (
                <Drawer
                     sx={{
                         width: `${SIDE_BAR_WIDTH}px`,
                         flexShrink: '0',
                         position: 'relative',
                         top: '50px',
                         '& .MuiDrawer-paper': {
                             width: `${SIDE_BAR_WIDTH}px`,
                             paddingTop: '50px',
                             boxSizing: 'border-box',
                             backgroundColor: 'secondary.light',
                         },
                     }}
                     variant={'permanent'}
                     anchor="left"
                 >
                     {
                         course?.image && (
                             <MultiFormatImage
                                 image={course.image}
                                 alt={course.description}
                                 sx={{
                                     maxWidth: '100%',
                                     display: 'block',
                                 }}
                             />
                         )
                     }
                     <Box sx={{p: 2, paddingLeft: 3}}>
                         <Typography
                             component={'h2'}
                             sx={{
                                 fontWeight: 'bold',
                                 fontSize: '1.4rem',
                                 color: '#fff',
                                 mb: 1,
                             }}
                         >
                             {course.title}
                         </Typography>
                         <Typography
                             sx={{
                                 color: '#fff', 
                             }}
                         >
                             {course.description}
                         </Typography>
                     </Box>
                 </Drawer>
                )}
                <Box component='main' sx={{flexGrow: 1, maxWidth: '100%'}}>
                <Container sx={{py: 2}}>
                    <Grid container>
                        {lessons.map(lesson => (
                            <Grid
                                key={lesson.id}
                                sx={{px: 1, textDecoration: 'none', mb: 2}}
                                lg={4}
                                item
                                component={Link}
                                to={`${APP_URLs.LESSON}/${lesson.courseId}/${lesson.id}`}
                            >
                                <Paper sx={{overflow: 'hidden', pb: 2}}>
                                    {lesson?.image && (
                                        <MultiFormatImage
                                            image={lesson.image}
                                            alt={lesson.description}
                                            sx={{
                                                width: '100%',
                                                height: `${isSmallScreen? "inherit": "250px"}`,
                                                objectFit: 'cover',
                                            }}
                                        />
                                    )}
                                    <Box sx={{p: 2, paddingBottom: 0}}>
                                        <Typography
                                            component='h2'
                                            sx={{
                                                fontWeight: 'bold',
                                                fontSize: '1.2em',
                                                minHeight: '3.5em',
                                                WebkitLineClamp: {md: '2'},
                                                lineClamp: {md: '2'},
                                                display: {md: '-webkit-box'},
                                                overflow: {md: 'hidden'},
                                                WebkitBoxOrient: {md: 'vertical'},
                                                boxOrient: {md: 'vertical'},
                                            }}
                                        >
                                            {lesson.title}
                                        </Typography>
                                        <Typography
                                            sx={isSmallScreen
                                                    ? {} 
                                                    : {
                                                        WebkitLineClamp: '3',
                                                        lineClamp: '3',
                                                        display: '-webkit-box',
                                                        overflow: 'hidden',
                                                        WebkitBoxOrient: 'vertical',
                                                        boxOrient: 'vertical',
                                                        marginBottom: 2,
                                                    }
                                            }
                                        >
                                            {lesson.description}
                                        </Typography>
                                       {lesson.results.maxScore === lesson.results.score
                                        ? <CheckIcon color="success"/>
                                        : <Typography sx={{color: 'secondary.light', lineHeight: '28px'}}>{lesson.results.score} из {lesson.results.maxScore}</Typography>
                                        }
                                    </Box>
                                </Paper>
                            </Grid>
                        ))}
                    </Grid>
                </Container>
                </Box>
            </Box>

        </>
    )
};

//@ts-ignore
const mapStateToProps = (state) => { 
    return {
       lessons: []
    }
}

//@ts-expect-error
const dispatchProps = (dispatch) => ({
    fetchCourses: bindActionCreators(courseActions.fetchCourses, dispatch),
    fetchLessons: bindActionCreators(courseActions.fetchLessons, dispatch),
})

export default connect(mapStateToProps, dispatchProps)(View);